/**
 * Stable ordering for template KPI rows: category, then sub category, then
 * title. This is the exact contiguity the merged Category / Sub Category
 * columns in `buildTemplateWorkbook` depend on, so it is the single source of
 * truth for that order — both the grouper and the workbook builder sort with
 * it. Missing category / sub category collapse to "Other" so untagged rows
 * cluster together instead of scattering.
 *
 * @param {{ category?: string, subCategory?: string, title?: string }} a - a template item.
 * @param {{ category?: string, subCategory?: string, title?: string }} b - the item to compare against.
 * @returns {number} negative / zero / positive, per `Array.prototype.sort`.
 */
export const compareTemplateItems = (a, b) =>
  (a.category || "Other").localeCompare(b.category || "Other")
  || (a.subCategory || "Other").localeCompare(b.subCategory || "Other")
  || (a.title || "").localeCompare(b.title || "");
